import React, { useState } from 'react'
import { GlassMagnifier } from 'react-image-magnifiers'

const noop = () => {}

export const MagnifyImage = props => {
    const { url, alt, title, largeImageUrl } = props

    // Prevents the zoomed image from loading when it's not required.
    // This is to improve page speed performance.
    const [isInteracted, setIsInteracted] = useState(false)

    return (
        <div
            className="w-full"
            onMouseEnter={e => {
                if (!isInteracted) {
                    setIsInteracted(true)
                }
            }}
        >
            {/* GlassMagnifier relies on function-component defaultProps, which React 19 ignores,
                so its defaults are passed explicitly here */}
            <GlassMagnifier
                imageSrc={url}
                imageAlt={alt || title || ''}
                magnifierSize="33%"
                largeImageSrc={isInteracted ? largeImageUrl || url : null}
                allowOverflow={false}
                magnifierBorderSize={3}
                magnifierBorderColor="rgba(255,255,255,.5)"
                magnifierBackgroundColor="rgba(225,225,225,.5)"
                magnifierOffsetX={0}
                magnifierOffsetY={0}
                square={false}
                cursorStyle="none"
                onImageLoad={noop}
                onLargeImageLoad={noop}
                style={{
                    width: '100%',
                }}
            />
        </div>
    )
}
